






























































































































import { GetInvoicesForRappelsQuery, GetProjectPurchaseOverviewQuery, InvoicesClient, ProjectPurchaseOverviewDto, ProjectsClient } from '@/data/web-api-client';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import MailPopupRappel from '@/modules/invoicing/components/MailPopupRappel.vue';

@Component({
  components: {
    Card,
    MailPopupRappel,
  },
})
export default class ProjectPurchaseOverview extends Vue {
  @Prop({ required: true })
  private project!: any;

  private purchaseOverview: ProjectPurchaseOverviewDto = new ProjectPurchaseOverviewDto();

  private async mounted() {
    this.loadData();
  }

  private async loadData() {
    var result = await new ProjectsClient(undefined, this.$axios).getPurchaseOverview(new GetProjectPurchaseOverviewQuery({ projectId: this.project.id }));
    this.purchaseOverview = result;
  }

  private async sendRappels() {
    try {
      const result = await new InvoicesClient(undefined, this.$axios).getInvoicesRappels(new GetInvoicesForRappelsQuery({ projectId: this.project.id }));
      var items = result.reduce((group, invoice) => {
        let index = invoice.customer!.id!;
        if (!group[index]) {
          group[index] = [];
        }
        group[index].push(invoice);
        return group;
      }, {} as { [key: string]: any });

      this.openMailDialog(Object.values(items));
    } catch {}
  }

  private openMailDialog(invoices: any[]) {
    (this.$refs.MailPopupRappel as MailPopupRappel).open(invoices);
  }
}
